





import { Component } from "vue-property-decorator";
import Vue from "vue";

@Component
export class LoadingIndicatorComponent extends Vue {}

Vue.component("sv-loading-indicator", LoadingIndicatorComponent);
export default LoadingIndicatorComponent;
